module.exports = __webpack_public_path__ + "static/media/mobile_separator_06.dfc3a2ab.webp";